import { Flame } from "lucide-react";

export function SpiceLevel({ level = 1, ariaLabel }) {
  return (
    <div
      className="inline-flex items-center gap-1 text-chilli"
      aria-label={ariaLabel || `Spice level ${level} of 3`}
      data-testid={`spice-level-${level}`}
    >
      {[1, 2, 3].map((n) => (
        <Flame
          key={n}
          aria-hidden="true"
          size={14}
          className={n <= level ? "opacity-100" : "opacity-25"}
          fill={n <= level ? "currentColor" : "none"}
          strokeWidth={2}
        />
      ))}
    </div>
  );
}

export function VegBadge({ type }) {
  const isVeg = type === "veg";
  const color = isVeg ? "#2E7D32" : "#B91C1C";
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider"
      style={{ color }}
      data-testid={`veg-badge-${type}`}
    >
      <span
        aria-hidden="true"
        className="inline-block"
        style={{
          width: 12,
          height: 12,
          border: `1.5px solid ${color}`,
          borderRadius: 2,
          position: "relative",
        }}
      >
        <span
          style={{
            position: "absolute",
            inset: 2,
            background: color,
            borderRadius: isVeg ? 999 : 1,
          }}
        />
      </span>
      {isVeg ? "Veg" : "Non-Veg"}
    </span>
  );
}

export function LeafDivider({ label }) {
  return (
    <div className="divider-leaf w-full max-w-md mx-auto my-6" aria-hidden="true">
      <span className="font-display italic text-sm">{label || "॥"}</span>
    </div>
  );
}

export function GopuramMark({ className = "" }) {
  // Lightweight stylized gopuram silhouette as decorative SVG
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <path d="M32 4 L36 10 L32 12 L28 10 Z" />
      <path d="M22 14 H42 V20 H22 Z" />
      <path d="M20 22 H44 L46 28 H18 Z" />
      <path d="M18 30 H46 L48 38 H16 Z" />
      <path d="M16 40 H48 L50 50 H14 Z" />
      <path d="M14 52 H50 V60 H14 Z" />
      <path d="M30 52 V60 M34 52 V60" />
    </svg>
  );
}
